export default __webpack_public_path__ + "static/media/767.f1ef8a96.png";